// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"24276456","209":"24276456","536":"24276456","865":"24276456"}[chunkId] + ".chunk.css";
};